/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
/* eslint-disable max-len */
export var IconName;
(function (IconName) {
    IconName["Icon0CircleFill"] = "twbs/0_circle-fill.svg";
    IconName["Icon0CircleHalf"] = "twbs/0_circle-half.svg";
    IconName["Icon0CircleSquare"] = "twbs/0_circle-square.svg";
    IconName["Icon0Circle"] = "twbs/0_circle.svg";
    IconName["Icon0SquareFill"] = "twbs/0_square-fill.svg";
    IconName["Icon0SquareHalf"] = "twbs/0_square-half.svg";
    IconName["Icon0Square"] = "twbs/0_square.svg";
    IconName["Icon0StarFill"] = "twbs/0_star-fill.svg";
    IconName["Icon0StarHalf"] = "twbs/0_star-half.svg";
    IconName["Icon0Star"] = "twbs/0_star.svg";
    IconName["Icon0Stars"] = "twbs/0_stars.svg";
    IconName["Icon0TriangleFill"] = "twbs/0_triangle-fill.svg";
    IconName["Icon0TriangleHalf"] = "twbs/0_triangle-half.svg";
    IconName["Icon0Triangle"] = "twbs/0_triangle.svg";
    IconName["IconArrow90DegDown"] = "twbs/arrow-90deg-down.svg";
    IconName["IconArrow90DegLeft"] = "twbs/arrow-90deg-left.svg";
    IconName["IconArrow90DegRight"] = "twbs/arrow-90deg-right.svg";
    IconName["IconArrow90DegUp"] = "twbs/arrow-90deg-up.svg";
    IconName["IconArrowClockwise"] = "twbs/arrow-clockwise.svg";
    IconName["IconArrowCounterclockwise"] = "twbs/arrow-counterclockwise.svg";
    IconName["IconArrowDownCircleFill"] = "twbs/arrow-down-circle-fill.svg";
    IconName["IconArrowDownCircle"] = "twbs/arrow-down-circle.svg";
    IconName["IconArrowDownLeftCircleFill"] = "twbs/arrow-down-left-circle-fill.svg";
    IconName["IconArrowDownLeftCircle"] = "twbs/arrow-down-left-circle.svg";
    IconName["IconArrowDownLeftSquareFill"] = "twbs/arrow-down-left-square-fill.svg";
    IconName["IconArrowDownLeftSquare"] = "twbs/arrow-down-left-square.svg";
    IconName["IconArrowDownLeft"] = "twbs/arrow-down-left.svg";
    IconName["IconArrowDownRightCircleFill"] = "twbs/arrow-down-right-circle-fill.svg";
    IconName["IconArrowDownRightCircle"] = "twbs/arrow-down-right-circle.svg";
    IconName["IconArrowDownRightSquareFill"] = "twbs/arrow-down-right-square-fill.svg";
    IconName["IconArrowDownRightSquare"] = "twbs/arrow-down-right-square.svg";
    IconName["IconArrowDownRight"] = "twbs/arrow-down-right.svg";
    IconName["IconArrowDownShort"] = "twbs/arrow-down-short.svg";
    IconName["IconArrowDownSquareFill"] = "twbs/arrow-down-square-fill.svg";
    IconName["IconArrowDownSquare"] = "twbs/arrow-down-square.svg";
    IconName["IconArrowDownUp"] = "twbs/arrow-down-up.svg";
    IconName["IconArrowDown"] = "twbs/arrow-down.svg";
    IconName["IconArrowLeftCircleFill"] = "twbs/arrow-left-circle-fill.svg";
    IconName["IconArrowLeftCircle"] = "twbs/arrow-left-circle.svg";
    IconName["IconArrowLeftRight"] = "twbs/arrow-left-right.svg";
    IconName["IconArrowLeftShort"] = "twbs/arrow-left-short.svg";
    IconName["IconArrowLeftSquareFill"] = "twbs/arrow-left-square-fill.svg";
    IconName["IconArrowLeftSquare"] = "twbs/arrow-left-square.svg";
    IconName["IconArrowLeft"] = "twbs/arrow-left.svg";
    IconName["IconArrowRepeat"] = "twbs/arrow-repeat.svg";
    IconName["IconArrowReturnLeft"] = "twbs/arrow-return-left.svg";
    IconName["IconArrowReturnRight"] = "twbs/arrow-return-right.svg";
    IconName["IconArrowRightCircleFill"] = "twbs/arrow-right-circle-fill.svg";
    IconName["IconArrowRightCircle"] = "twbs/arrow-right-circle.svg";
    IconName["IconArrowRightShort"] = "twbs/arrow-right-short.svg";
    IconName["IconArrowRightSquareFill"] = "twbs/arrow-right-square-fill.svg";
    IconName["IconArrowRightSquare"] = "twbs/arrow-right-square.svg";
    IconName["IconArrowRight"] = "twbs/arrow-right.svg";
    IconName["IconArrowUpCircleFill"] = "twbs/arrow-up-circle-fill.svg";
    IconName["IconArrowUpCircle"] = "twbs/arrow-up-circle.svg";
    IconName["IconArrowUpLeftCircleFill"] = "twbs/arrow-up-left-circle-fill.svg";
    IconName["IconArrowUpLeftCircle"] = "twbs/arrow-up-left-circle.svg";
    IconName["IconArrowUpLeftSquareFill"] = "twbs/arrow-up-left-square-fill.svg";
    IconName["IconArrowUpLeftSquare"] = "twbs/arrow-up-left-square.svg";
    IconName["IconArrowUpLeft"] = "twbs/arrow-up-left.svg";
    IconName["IconArrowUpRightCircleFill"] = "twbs/arrow-up-right-circle-fill.svg";
    IconName["IconArrowUpRightCircle"] = "twbs/arrow-up-right-circle.svg";
    IconName["IconArrowUpRightSquareFill"] = "twbs/arrow-up-right-square-fill.svg";
    IconName["IconArrowUpRightSquare"] = "twbs/arrow-up-right-square.svg";
    IconName["IconArrowUpRight"] = "twbs/arrow-up-right.svg";
    IconName["IconArrowUpShort"] = "twbs/arrow-up-short.svg";
    IconName["IconArrowUpSquareFill"] = "twbs/arrow-up-square-fill.svg";
    IconName["IconArrowUpSquare"] = "twbs/arrow-up-square.svg";
    IconName["IconArrowUp"] = "twbs/arrow-up.svg";
    IconName["IconArrowsAngleContract"] = "twbs/arrows-angle-contract.svg";
    IconName["IconArrowsFullscreen"] = "twbs/arrows-fullscreen.svg";
    IconName["IconArrowsMove"] = "twbs/arrows-move.svg";
    IconName["IconBagCheckFill"] = "twbs/bag-check-fill.svg";
    IconName["IconBagCheck"] = "twbs/bag-check.svg";
    IconName["IconBagDashFill"] = "twbs/bag-dash-fill.svg";
    IconName["IconBagDash"] = "twbs/bag-dash.svg";
    IconName["IconBagFill"] = "twbs/bag-fill.svg";
    IconName["IconBagPlusFill"] = "twbs/bag-plus-fill.svg";
    IconName["IconBagPlus"] = "twbs/bag-plus.svg";
    IconName["IconBagXFill"] = "twbs/bag-x-fill.svg";
    IconName["IconBagX"] = "twbs/bag-x.svg";
    IconName["IconBag"] = "twbs/bag.svg";
    IconName["IconBank"] = "twbs/bank.svg";
    IconName["IconBank2"] = "twbs/bank2.svg";
    IconName["IconBasketFill"] = "twbs/basket-fill.svg";
    IconName["IconBasket"] = "twbs/basket.svg";
    IconName["IconBasket2Fill"] = "twbs/basket2-fill.svg";
    IconName["IconBasket2"] = "twbs/basket2.svg";
    IconName["IconBasket3Fill"] = "twbs/basket3-fill.svg";
    IconName["IconBasket3"] = "twbs/basket3.svg";
    IconName["IconBicycle"] = "twbs/bicycle.svg";
    IconName["IconBinocularsFill"] = "twbs/binoculars-fill.svg";
    IconName["IconBinoculars"] = "twbs/binoculars.svg";
    IconName["IconBookFill"] = "twbs/book-fill.svg";
    IconName["IconBookHalf"] = "twbs/book-half.svg";
    IconName["IconBoxArrowDownLeft"] = "twbs/box-arrow-down-left.svg";
    IconName["IconBoxArrowDownRight"] = "twbs/box-arrow-down-right.svg";
    IconName["IconBoxArrowInDownLeft"] = "twbs/box-arrow-in-down-left.svg";
    IconName["IconBoxArrowInDownRight"] = "twbs/box-arrow-in-down-right.svg";
    IconName["IconBoxArrowInDown"] = "twbs/box-arrow-in-down.svg";
    IconName["IconBoxArrowInLeft"] = "twbs/box-arrow-in-left.svg";
    IconName["IconBoxArrowInRight"] = "twbs/box-arrow-in-right.svg";
    IconName["IconBoxArrowInUpLeft"] = "twbs/box-arrow-in-up-left.svg";
    IconName["IconBoxArrowInUpRight"] = "twbs/box-arrow-in-up-right.svg";
    IconName["IconBoxArrowInUp"] = "twbs/box-arrow-in-up.svg";
    IconName["IconBoxArrowLeft"] = "twbs/box-arrow-left.svg";
    IconName["IconBoxArrowRight"] = "twbs/box-arrow-right.svg";
    IconName["IconBoxArrowUpLeft"] = "twbs/box-arrow-up-left.svg";
    IconName["IconBoxArrowUpRight"] = "twbs/box-arrow-up-right.svg";
    IconName["IconBoxArrowUp"] = "twbs/box-arrow-up.svg";
    IconName["IconBoxSeam"] = "twbs/box-seam.svg";
    IconName["IconBox"] = "twbs/box.svg";
    IconName["IconBrightnessAltHighFill"] = "twbs/brightness-alt-high-fill.svg";
    IconName["IconBrightnessAltHigh"] = "twbs/brightness-alt-high.svg";
    IconName["IconBrightnessAltLowFill"] = "twbs/brightness-alt-low-fill.svg";
    IconName["IconBrightnessAltLow"] = "twbs/brightness-alt-low.svg";
    IconName["IconBrightnessHighFill"] = "twbs/brightness-high-fill.svg";
    IconName["IconBrightnessHigh"] = "twbs/brightness-high.svg";
    IconName["IconBrightnessLowFill"] = "twbs/brightness-low-fill.svg";
    IconName["IconBrightnessLow"] = "twbs/brightness-low.svg";
    IconName["IconBroadcastPin"] = "twbs/broadcast-pin.svg";
    IconName["IconBroadcast"] = "twbs/broadcast.svg";
    IconName["IconBucketFill"] = "twbs/bucket-fill.svg";
    IconName["IconBucket"] = "twbs/bucket.svg";
    IconName["IconBugFill"] = "twbs/bug-fill.svg";
    IconName["IconBug"] = "twbs/bug.svg";
    IconName["IconCameraFill"] = "twbs/camera-fill.svg";
    IconName["IconCameraReelsFill"] = "twbs/camera-reels-fill.svg";
    IconName["IconCameraReels"] = "twbs/camera-reels.svg";
    IconName["IconCameraVideoFill"] = "twbs/camera-video-fill.svg";
    IconName["IconCameraVideoOffFill"] = "twbs/camera-video-off-fill.svg";
    IconName["IconCameraVideoOff"] = "twbs/camera-video-off.svg";
    IconName["IconCameraVideo"] = "twbs/camera-video.svg";
    IconName["IconCamera"] = "twbs/camera.svg";
    IconName["IconCamera2"] = "twbs/camera2.svg";
    IconName["IconCartCheckFill"] = "twbs/cart-check-fill.svg";
    IconName["IconCartCheck"] = "twbs/cart-check.svg";
    IconName["IconCartDashFill"] = "twbs/cart-dash-fill.svg";
    IconName["IconCartDash"] = "twbs/cart-dash.svg";
    IconName["IconCartFill"] = "twbs/cart-fill.svg";
    IconName["IconCartPlusFill"] = "twbs/cart-plus-fill.svg";
    IconName["IconCartPlus"] = "twbs/cart-plus.svg";
    IconName["IconCartXFill"] = "twbs/cart-x-fill.svg";
    IconName["IconCartX"] = "twbs/cart-x.svg";
    IconName["IconCart"] = "twbs/cart.svg";
    IconName["IconCart2"] = "twbs/cart2.svg";
    IconName["IconCart3"] = "twbs/cart3.svg";
    IconName["IconCart4"] = "twbs/cart4.svg";
    IconName["IconCashCoin"] = "twbs/cash-coin.svg";
    IconName["IconCashStack"] = "twbs/cash-stack.svg";
    IconName["IconCash"] = "twbs/cash.svg";
    IconName["IconCloudArrowDownFill"] = "twbs/cloud-arrow-down-fill.svg";
    IconName["IconCloudArrowDown"] = "twbs/cloud-arrow-down.svg";
    IconName["IconCloudArrowUpFill"] = "twbs/cloud-arrow-up-fill.svg";
    IconName["IconCloudArrowUp"] = "twbs/cloud-arrow-up.svg";
    IconName["IconCloudCheckFill"] = "twbs/cloud-check-fill.svg";
    IconName["IconCloudCheck"] = "twbs/cloud-check.svg";
    IconName["IconCloudDrizzleFill"] = "twbs/cloud-drizzle-fill.svg";
    IconName["IconCloudDrizzle"] = "twbs/cloud-drizzle.svg";
    IconName["IconCloudFill"] = "twbs/cloud-fill.svg";
    IconName["IconCloudFogFill"] = "twbs/cloud-fog-fill.svg";
    IconName["IconCloudFog"] = "twbs/cloud-fog.svg";
    IconName["IconCloudFog2Fill"] = "twbs/cloud-fog2-fill.svg";
    IconName["IconCloudFog2"] = "twbs/cloud-fog2.svg";
    IconName["IconCloudHailFill"] = "twbs/cloud-hail-fill.svg";
    IconName["IconCloudHail"] = "twbs/cloud-hail.svg";
    IconName["IconCloudHaze1"] = "twbs/cloud-haze-1.svg";
    IconName["IconCloudHazeFill"] = "twbs/cloud-haze-fill.svg";
    IconName["IconCloudHaze"] = "twbs/cloud-haze.svg";
    IconName["IconCloudHaze2Fill"] = "twbs/cloud-haze2-fill.svg";
    IconName["IconCloudLightningFill"] = "twbs/cloud-lightning-fill.svg";
    IconName["IconCloudLightningRainFill"] = "twbs/cloud-lightning-rain-fill.svg";
    IconName["IconCloudLightningRain"] = "twbs/cloud-lightning-rain.svg";
    IconName["IconCloudLightning"] = "twbs/cloud-lightning.svg";
    IconName["IconCloudMinusFill"] = "twbs/cloud-minus-fill.svg";
    IconName["IconCloudMinus"] = "twbs/cloud-minus.svg";
    IconName["IconCloudMoonFill"] = "twbs/cloud-moon-fill.svg";
    IconName["IconCloudMoon"] = "twbs/cloud-moon.svg";
    IconName["IconCloudPlusFill"] = "twbs/cloud-plus-fill.svg";
    IconName["IconCloudPlus"] = "twbs/cloud-plus.svg";
    IconName["IconCloudRainFill"] = "twbs/cloud-rain-fill.svg";
    IconName["IconCloudRainHeavyFill"] = "twbs/cloud-rain-heavy-fill.svg";
    IconName["IconCloudRainHeavy"] = "twbs/cloud-rain-heavy.svg";
    IconName["IconCloudRain"] = "twbs/cloud-rain.svg";
    IconName["IconCloudSlashFill"] = "twbs/cloud-slash-fill.svg";
    IconName["IconCloudSlash"] = "twbs/cloud-slash.svg";
    IconName["IconCloudSleetFill"] = "twbs/cloud-sleet-fill.svg";
    IconName["IconCloudSleet"] = "twbs/cloud-sleet.svg";
    IconName["IconCloudSnowFill"] = "twbs/cloud-snow-fill.svg";
    IconName["IconCloudSnow"] = "twbs/cloud-snow.svg";
    IconName["IconCloudSunFill"] = "twbs/cloud-sun-fill.svg";
    IconName["IconCloudSun"] = "twbs/cloud-sun.svg";
    IconName["IconCloudUploadFill"] = "twbs/cloud-upload-fill.svg";
    IconName["IconCloudUpload"] = "twbs/cloud-upload.svg";
    IconName["IconCompassFill"] = "twbs/compass-fill.svg";
    IconName["IconCompass"] = "twbs/compass.svg";
    IconName["IconCreditCard2BackFill"] = "twbs/credit-card-2-back-fill.svg";
    IconName["IconCreditCard2Back"] = "twbs/credit-card-2-back.svg";
    IconName["IconCreditCard2FrontFill"] = "twbs/credit-card-2-front-fill.svg";
    IconName["IconCreditCard2Front"] = "twbs/credit-card-2-front.svg";
    IconName["IconCreditCardFill"] = "twbs/credit-card-fill.svg";
    IconName["IconCreditCard"] = "twbs/credit-card.svg";
    IconName["IconCupFill"] = "twbs/cup-fill.svg";
    IconName["IconCupStraw"] = "twbs/cup-straw.svg";
    IconName["IconCup"] = "twbs/cup.svg";
    IconName["IconCurrencyBitcoin"] = "twbs/currency-bitcoin.svg";
    IconName["IconCurrencyDollar"] = "twbs/currency-dollar.svg";
    IconName["IconCurrencyEuro"] = "twbs/currency-euro.svg";
    IconName["IconCurrencyExchange"] = "twbs/currency-exchange.svg";
    IconName["IconCurrencyPound"] = "twbs/currency-pound.svg";
    IconName["IconCurrencyYen"] = "twbs/currency-yen.svg";
    IconName["IconDiamondFill"] = "twbs/diamond-fill.svg";
    IconName["IconDiamondHalf"] = "twbs/diamond-half.svg";
    IconName["IconDiamond"] = "twbs/diamond.svg";
    IconName["IconDice1Fill"] = "twbs/dice-1-fill.svg";
    IconName["IconDice1"] = "twbs/dice-1.svg";
    IconName["IconDice2Fill"] = "twbs/dice-2-fill.svg";
    IconName["IconDice2"] = "twbs/dice-2.svg";
    IconName["IconDice3Fill"] = "twbs/dice-3-fill.svg";
    IconName["IconDice3"] = "twbs/dice-3.svg";
    IconName["IconDice4Fill"] = "twbs/dice-4-fill.svg";
    IconName["IconDice4"] = "twbs/dice-4.svg";
    IconName["IconDice5Fill"] = "twbs/dice-5-fill.svg";
    IconName["IconDice5"] = "twbs/dice-5.svg";
    IconName["IconDice6Fill"] = "twbs/dice-6-fill.svg";
    IconName["IconDice6"] = "twbs/dice-6.svg";
    IconName["IconDiscFill"] = "twbs/disc-fill.svg";
    IconName["IconDisc"] = "twbs/disc.svg";
    IconName["IconDiscord"] = "twbs/discord.svg";
    IconName["IconDoorClosedFill"] = "twbs/door-closed-fill.svg";
    IconName["IconDoorClosed"] = "twbs/door-closed.svg";
    IconName["IconDoorOpenFill"] = "twbs/door-open-fill.svg";
    IconName["IconDoorOpen"] = "twbs/door-open.svg";
    IconName["IconDropletFill"] = "twbs/droplet-fill.svg";
    IconName["IconDropletHalf"] = "twbs/droplet-half.svg";
    IconName["IconEggFill"] = "twbs/egg-fill.svg";
    IconName["IconEggFried"] = "twbs/egg-fried.svg";
    IconName["IconEgg"] = "twbs/egg.svg";
    IconName["IconEmojiAngryFill"] = "twbs/emoji-angry-fill.svg";
    IconName["IconEmojiAngry"] = "twbs/emoji-angry.svg";
    IconName["IconEmojiDizzyFill"] = "twbs/emoji-dizzy-fill.svg";
    IconName["IconEmojiDizzy"] = "twbs/emoji-dizzy.svg";
    IconName["IconEmojiExpressionlessFill"] = "twbs/emoji-expressionless-fill.svg";
    IconName["IconEmojiExpressionless"] = "twbs/emoji-expressionless.svg";
    IconName["IconEmojiFrownFill"] = "twbs/emoji-frown-fill.svg";
    IconName["IconEmojiFrown"] = "twbs/emoji-frown.svg";
    IconName["IconEmojiHeartEyesFill"] = "twbs/emoji-heart-eyes-fill.svg";
    IconName["IconEmojiHeartEyes"] = "twbs/emoji-heart-eyes.svg";
    IconName["IconEmojiLaughingFill"] = "twbs/emoji-laughing-fill.svg";
    IconName["IconEmojiLaughing"] = "twbs/emoji-laughing.svg";
    IconName["IconEmojiNeutralFill"] = "twbs/emoji-neutral-fill.svg";
    IconName["IconEmojiNeutral"] = "twbs/emoji-neutral.svg";
    IconName["IconEmojiSmileFill"] = "twbs/emoji-smile-fill.svg";
    IconName["IconEmojiSmileUpsideDownFill"] = "twbs/emoji-smile-upside-down-fill.svg";
    IconName["IconEmojiSmileUpsideDown"] = "twbs/emoji-smile-upside-down.svg";
    IconName["IconEmojiSmile"] = "twbs/emoji-smile.svg";
    IconName["IconEmojiSunglassesFill"] = "twbs/emoji-sunglasses-fill.svg";
    IconName["IconEmojiSunglasses"] = "twbs/emoji-sunglasses.svg";
    IconName["IconEmojiWinkFill"] = "twbs/emoji-wink-fill.svg";
    IconName["IconEmojiWink"] = "twbs/emoji-wink.svg";
    IconName["IconEnvelopeFill"] = "twbs/envelope-fill.svg";
    IconName["IconEnvelopeOpenFill"] = "twbs/envelope-open-fill.svg";
    IconName["IconEnvelopeOpen"] = "twbs/envelope-open.svg";
    IconName["IconEnvelope"] = "twbs/envelope.svg";
    IconName["IconExclamationCircleFill"] = "twbs/exclamation-circle-fill.svg";
    IconName["IconExclamationCircle"] = "twbs/exclamation-circle.svg";
    IconName["IconExclamationDiamondFill"] = "twbs/exclamation-diamond-fill.svg";
    IconName["IconExclamationDiamond"] = "twbs/exclamation-diamond.svg";
    IconName["IconExclamationLg"] = "twbs/exclamation-lg.svg";
    IconName["IconExclamationOctagonFill"] = "twbs/exclamation-octagon-fill.svg";
    IconName["IconExclamationOctagon"] = "twbs/exclamation-octagon.svg";
    IconName["IconExclamationSquareFill"] = "twbs/exclamation-square-fill.svg";
    IconName["IconExclamationSquare"] = "twbs/exclamation-square.svg";
    IconName["IconExclamationTriangleFill"] = "twbs/exclamation-triangle-fill.svg";
    IconName["IconExclamationTriangle"] = "twbs/exclamation-triangle.svg";
    IconName["IconExclamation"] = "twbs/exclamation.svg";
    IconName["IconExclude"] = "twbs/exclude.svg";
    IconName["IconEyeFill"] = "twbs/eye-fill.svg";
    IconName["IconEyeSlashFill"] = "twbs/eye-slash-fill.svg";
    IconName["IconEyeSlash"] = "twbs/eye-slash.svg";
    IconName["IconEye"] = "twbs/eye.svg";
    IconName["IconEyedropper"] = "twbs/eyedropper.svg";
    IconName["IconEyeglasses"] = "twbs/eyeglasses.svg";
    IconName["IconFlower1"] = "twbs/flower1.svg";
    IconName["IconFlower2"] = "twbs/flower2.svg";
    IconName["IconFlower3"] = "twbs/flower3.svg";
    IconName["IconFunnelFill"] = "twbs/funnel-fill.svg";
    IconName["IconFunnel"] = "twbs/funnel.svg";
    IconName["IconGearFill"] = "twbs/gear-fill.svg";
    IconName["IconGearWideConnected"] = "twbs/gear-wide-connected.svg";
    IconName["IconGearWide"] = "twbs/gear-wide.svg";
    IconName["IconGear"] = "twbs/gear.svg";
    IconName["IconGem"] = "twbs/gem.svg";
    IconName["IconGeoAltFill"] = "twbs/geo-alt-fill.svg";
    IconName["IconGeoAlt"] = "twbs/geo-alt.svg";
    IconName["IconGeoFill"] = "twbs/geo-fill.svg";
    IconName["IconGeo"] = "twbs/geo.svg";
    IconName["IconHammer"] = "twbs/hammer.svg";
    IconName["IconHandbagFill"] = "twbs/handbag-fill.svg";
    IconName["IconHandbag"] = "twbs/handbag.svg";
    IconName["IconHeartFill"] = "twbs/heart-fill.svg";
    IconName["IconHeartHalf"] = "twbs/heart-half.svg";
    IconName["IconHeart"] = "twbs/heart.svg";
    IconName["IconHeptagonFill"] = "twbs/heptagon-fill.svg";
    IconName["IconHeptagonHalf"] = "twbs/heptagon-half.svg";
    IconName["IconHeptagon"] = "twbs/heptagon.svg";
    IconName["IconHouseDoorFill"] = "twbs/house-door-fill.svg";
    IconName["IconHouseDoor"] = "twbs/house-door.svg";
    IconName["IconHouseFill"] = "twbs/house-fill.svg";
    IconName["IconHouse"] = "twbs/house.svg";
    IconName["IconHurricane"] = "twbs/hurricane.svg";
    IconName["IconInfoCircleFill"] = "twbs/info-circle-fill.svg";
    IconName["IconInfoCircle"] = "twbs/info-circle.svg";
    IconName["IconInfoLg"] = "twbs/info-lg.svg";
    IconName["IconInfoSquareFill"] = "twbs/info-square-fill.svg";
    IconName["IconInfoSquare"] = "twbs/info-square.svg";
    IconName["IconInfo"] = "twbs/info.svg";
    IconName["IconJournalAlbum"] = "twbs/journal-album.svg";
    IconName["IconJournalCheck"] = "twbs/journal-check.svg";
    IconName["IconLadder"] = "twbs/ladder.svg";
    IconName["IconLifePreserver"] = "twbs/life-preserver.svg";
    IconName["IconLightbulbFill"] = "twbs/lightbulb-fill.svg";
    IconName["IconLightbulbOffFill"] = "twbs/lightbulb-off-fill.svg";
    IconName["IconLightbulbOff"] = "twbs/lightbulb-off.svg";
    IconName["IconLightbulb"] = "twbs/lightbulb.svg";
    IconName["IconLightningChargeFill"] = "twbs/lightning-charge-fill.svg";
    IconName["IconLightningCharge"] = "twbs/lightning-charge.svg";
    IconName["IconLightningFill"] = "twbs/lightning-fill.svg";
    IconName["IconLightning"] = "twbs/lightning.svg";
    IconName["IconLink45Deg"] = "twbs/link-45deg.svg";
    IconName["IconLink"] = "twbs/link.svg";
    IconName["IconLinkedin"] = "twbs/linkedin.svg";
    IconName["IconMapFill"] = "twbs/map-fill.svg";
    IconName["IconMap"] = "twbs/map.svg";
    IconName["IconMinecartLoaded"] = "twbs/minecart-loaded.svg";
    IconName["IconMinecart"] = "twbs/minecart.svg";
    IconName["IconMoisture"] = "twbs/moisture.svg";
    IconName["IconMoonFill"] = "twbs/moon-fill.svg";
    IconName["IconMoonStarsFill"] = "twbs/moon-stars-fill.svg";
    IconName["IconMoonStars"] = "twbs/moon-stars.svg";
    IconName["IconMoon"] = "twbs/moon.svg";
    IconName["IconMusicNoteBeamed"] = "twbs/music-note-beamed.svg";
    IconName["IconMusicNoteList"] = "twbs/music-note-list.svg";
    IconName["IconMusicNote"] = "twbs/music-note.svg";
    IconName["IconMusicPlayerFill"] = "twbs/music-player-fill.svg";
    IconName["IconMusicPlayer"] = "twbs/music-player.svg";
    IconName["IconNutFill"] = "twbs/nut-fill.svg";
    IconName["IconNut"] = "twbs/nut.svg";
    IconName["IconOctagonFill"] = "twbs/octagon-fill.svg";
    IconName["IconOctagonHalf"] = "twbs/octagon-half.svg";
    IconName["IconOctagon"] = "twbs/octagon.svg";
    IconName["IconOutlet"] = "twbs/outlet.svg";
    IconName["IconPaintBucket"] = "twbs/paint-bucket.svg";
    IconName["IconPaletteFill"] = "twbs/palette-fill.svg";
    IconName["IconPalette"] = "twbs/palette.svg";
    IconName["IconPalette2"] = "twbs/palette2.svg";
    IconName["IconPatchCheckFill"] = "twbs/patch-check-fill.svg";
    IconName["IconPatchCheck"] = "twbs/patch-check.svg";
    IconName["IconPatchExclamationFill"] = "twbs/patch-exclamation-fill.svg";
    IconName["IconPatchExclamation"] = "twbs/patch-exclamation.svg";
    IconName["IconPatchMinusFill"] = "twbs/patch-minus-fill.svg";
    IconName["IconPatchMinus"] = "twbs/patch-minus.svg";
    IconName["IconPatchPlusFill"] = "twbs/patch-plus-fill.svg";
    IconName["IconPatchPlus"] = "twbs/patch-plus.svg";
    IconName["IconPatchQuestionFill"] = "twbs/patch-question-fill.svg";
    IconName["IconPatchQuestion"] = "twbs/patch-question.svg";
    IconName["IconPeaceFill"] = "twbs/peace-fill.svg";
    IconName["IconPeace"] = "twbs/peace.svg";
    IconName["IconPencilFill"] = "twbs/pencil-fill.svg";
    IconName["IconPencilSquare"] = "twbs/pencil-square.svg";
    IconName["IconPencil"] = "twbs/pencil.svg";
    IconName["IconPentagonFill"] = "twbs/pentagon-fill.svg";
    IconName["IconPentagonHalf"] = "twbs/pentagon-half.svg";
    IconName["IconPentagon"] = "twbs/pentagon.svg";
    IconName["IconPeopleFill"] = "twbs/people-fill.svg";
    IconName["IconPeople"] = "twbs/people.svg";
    IconName["IconPersonBadgeFill"] = "twbs/person-badge-fill.svg";
    IconName["IconPersonBadge"] = "twbs/person-badge.svg";
    IconName["IconPersonBoundingBox"] = "twbs/person-bounding-box.svg";
    IconName["IconPersonCheckFill"] = "twbs/person-check-fill.svg";
    IconName["IconPersonCheck"] = "twbs/person-check.svg";
    IconName["IconPersonCircle"] = "twbs/person-circle.svg";
    IconName["IconPersonDashFill"] = "twbs/person-dash-fill.svg";
    IconName["IconPersonDash"] = "twbs/person-dash.svg";
    IconName["IconPersonFill"] = "twbs/person-fill.svg";
    IconName["IconPersonLinesFill"] = "twbs/person-lines-fill.svg";
    IconName["IconPersonPlusFill"] = "twbs/person-plus-fill.svg";
    IconName["IconPersonPlus"] = "twbs/person-plus.svg";
    IconName["IconPersonSquare"] = "twbs/person-square.svg";
    IconName["IconPersonXFill"] = "twbs/person-x-fill.svg";
    IconName["IconPersonX"] = "twbs/person-x.svg";
    IconName["IconPerson"] = "twbs/person.svg";
    IconName["IconPiggyBankFill"] = "twbs/piggy-bank-fill.svg";
    IconName["IconPiggyBank"] = "twbs/piggy-bank.svg";
    IconName["IconPinAngleFill"] = "twbs/pin-angle-fill.svg";
    IconName["IconPinAngle"] = "twbs/pin-angle.svg";
    IconName["IconPinFill"] = "twbs/pin-fill.svg";
    IconName["IconPinMapFill"] = "twbs/pin-map-fill.svg";
    IconName["IconPinMap"] = "twbs/pin-map.svg";
    IconName["IconPin"] = "twbs/pin.svg";
    IconName["IconPlugFill"] = "twbs/plug-fill.svg";
    IconName["IconPlug"] = "twbs/plug.svg";
    IconName["IconPlusCircleDotted"] = "twbs/plus-circle-dotted.svg";
    IconName["IconPlusCircleFill"] = "twbs/plus-circle-fill.svg";
    IconName["IconPlusCircle"] = "twbs/plus-circle.svg";
    IconName["IconPlusLg"] = "twbs/plus-lg.svg";
    IconName["IconPlusSquareDotted"] = "twbs/plus-square-dotted.svg";
    IconName["IconPlusSquareFill"] = "twbs/plus-square-fill.svg";
    IconName["IconPlusSquare"] = "twbs/plus-square.svg";
    IconName["IconPlus"] = "twbs/plus.svg";
    IconName["IconQuestionCircleFill"] = "twbs/question-circle-fill.svg";
    IconName["IconQuestionCircle"] = "twbs/question-circle.svg";
    IconName["IconQuestionDiamondFill"] = "twbs/question-diamond-fill.svg";
    IconName["IconQuestionDiamond"] = "twbs/question-diamond.svg";
    IconName["IconQuestionLg"] = "twbs/question-lg.svg";
    IconName["IconQuestionOctagonFill"] = "twbs/question-octagon-fill.svg";
    IconName["IconQuestionOctagon"] = "twbs/question-octagon.svg";
    IconName["IconQuestionSquareFill"] = "twbs/question-square-fill.svg";
    IconName["IconQuestionSquare"] = "twbs/question-square.svg";
    IconName["IconQuestion"] = "twbs/question.svg";
    IconName["IconRainbow"] = "twbs/rainbow.svg";
    IconName["IconShieldCheck"] = "twbs/shield-check.svg";
    IconName["IconShieldExclamation"] = "twbs/shield-exclamation.svg";
    IconName["IconShieldFillCheck"] = "twbs/shield-fill-check.svg";
    IconName["IconShieldFillExclamation"] = "twbs/shield-fill-exclamation.svg";
    IconName["IconShieldFillMinus"] = "twbs/shield-fill-minus.svg";
    IconName["IconShieldFillPlus"] = "twbs/shield-fill-plus.svg";
    IconName["IconShieldFillX"] = "twbs/shield-fill-x.svg";
    IconName["IconShieldFill"] = "twbs/shield-fill.svg";
    IconName["IconShieldLockFill"] = "twbs/shield-lock-fill.svg";
    IconName["IconShieldLock"] = "twbs/shield-lock.svg";
    IconName["IconShieldMinus"] = "twbs/shield-minus.svg";
    IconName["IconShieldPlus"] = "twbs/shield-plus.svg";
    IconName["IconShieldShaded"] = "twbs/shield-shaded.svg";
    IconName["IconShieldSlashFill"] = "twbs/shield-slash-fill.svg";
    IconName["IconShieldSlash"] = "twbs/shield-slash.svg";
    IconName["IconShieldX"] = "twbs/shield-x.svg";
    IconName["IconShield"] = "twbs/shield.svg";
    IconName["IconSignpost2Fill"] = "twbs/signpost-2-fill.svg";
    IconName["IconSignpost2"] = "twbs/signpost-2.svg";
    IconName["IconSignpostFill"] = "twbs/signpost-fill.svg";
    IconName["IconSignpostSplitFill"] = "twbs/signpost-split-fill.svg";
    IconName["IconSignpostSplit"] = "twbs/signpost-split.svg";
    IconName["IconSignpost"] = "twbs/signpost.svg";
    IconName["IconSnow"] = "twbs/snow.svg";
    IconName["IconSnow2"] = "twbs/snow2.svg";
    IconName["IconSnow3"] = "twbs/snow3.svg";
    IconName["IconSuitClubFill"] = "twbs/suit-club-fill.svg";
    IconName["IconSuitClub"] = "twbs/suit-club.svg";
    IconName["IconSuitDiamondFill"] = "twbs/suit-diamond-fill.svg";
    IconName["IconSuitDiamond"] = "twbs/suit-diamond.svg";
    IconName["IconSuitHeartFill"] = "twbs/suit-heart-fill.svg";
    IconName["IconSuitHeart"] = "twbs/suit-heart.svg";
    IconName["IconSuitSpadeFill"] = "twbs/suit-spade-fill.svg";
    IconName["IconSuitSpade"] = "twbs/suit-spade.svg";
    IconName["IconSunFill"] = "twbs/sun-fill.svg";
    IconName["IconSun"] = "twbs/sun.svg";
    IconName["IconSunglasses"] = "twbs/sunglasses.svg";
    IconName["IconSunriseFill"] = "twbs/sunrise-fill.svg";
    IconName["IconSunrise"] = "twbs/sunrise.svg";
    IconName["IconSunsetFill"] = "twbs/sunset-fill.svg";
    IconName["IconSunset"] = "twbs/sunset.svg";
    IconName["IconTagFill"] = "twbs/tag-fill.svg";
    IconName["IconTag"] = "twbs/tag.svg";
    IconName["IconTagsFill"] = "twbs/tags-fill.svg";
    IconName["IconTags"] = "twbs/tags.svg";
    IconName["IconTelephoneFill"] = "twbs/telephone-fill.svg";
    IconName["IconTelephoneForwardFill"] = "twbs/telephone-forward-fill.svg";
    IconName["IconTelephoneForward"] = "twbs/telephone-forward.svg";
    IconName["IconTelephoneInboundFill"] = "twbs/telephone-inbound-fill.svg";
    IconName["IconTelephoneInbound"] = "twbs/telephone-inbound.svg";
    IconName["IconTelephoneMinusFill"] = "twbs/telephone-minus-fill.svg";
    IconName["IconTelephoneMinus"] = "twbs/telephone-minus.svg";
    IconName["IconTelephoneOutboundFill"] = "twbs/telephone-outbound-fill.svg";
    IconName["IconTelephoneOutbound"] = "twbs/telephone-outbound.svg";
    IconName["IconTelephonePlusFill"] = "twbs/telephone-plus-fill.svg";
    IconName["IconTelephonePlus"] = "twbs/telephone-plus.svg";
    IconName["IconTelephoneXFill"] = "twbs/telephone-x-fill.svg";
    IconName["IconTelephoneX"] = "twbs/telephone-x.svg";
    IconName["IconTelephone"] = "twbs/telephone.svg";
    IconName["IconThermometerHalf"] = "twbs/thermometer-half.svg";
    IconName["IconThermometerHigh"] = "twbs/thermometer-high.svg";
    IconName["IconThermometerLow"] = "twbs/thermometer-low.svg";
    IconName["IconThermometerSnow"] = "twbs/thermometer-snow.svg";
    IconName["IconThermometerSun"] = "twbs/thermometer-sun.svg";
    IconName["IconThermometer"] = "twbs/thermometer.svg";
    IconName["IconTrashFill"] = "twbs/trash-fill.svg";
    IconName["IconTrash"] = "twbs/trash.svg";
    IconName["IconTrash2Fill"] = "twbs/trash2-fill.svg";
    IconName["IconTrash2"] = "twbs/trash2.svg";
    IconName["IconTreeFill"] = "twbs/tree-fill.svg";
    IconName["IconTree"] = "twbs/tree.svg";
    IconName["IconTrophyFill"] = "twbs/trophy-fill.svg";
    IconName["IconTrophy"] = "twbs/trophy.svg";
    IconName["IconTropicalStorm"] = "twbs/tropical-storm.svg";
    IconName["IconTruckFlatbed"] = "twbs/truck-flatbed.svg";
    IconName["IconTruck"] = "twbs/truck.svg";
    IconName["IconTsunami"] = "twbs/tsunami.svg";
    IconName["IconUmbrellaFill"] = "twbs/umbrella-fill.svg";
    IconName["IconUmbrella"] = "twbs/umbrella.svg";
    IconName["IconUnion"] = "twbs/union.svg";
    IconName["IconUnlockFill"] = "twbs/unlock-fill.svg";
    IconName["IconUnlock"] = "twbs/unlock.svg";
    IconName["IconWatch"] = "twbs/watch.svg";
    IconName["IconWater"] = "twbs/water.svg";
    IconName["IconWifi1"] = "twbs/wifi-1.svg";
    IconName["IconWifi2"] = "twbs/wifi-2.svg";
    IconName["IconWifiOff"] = "twbs/wifi-off.svg";
    IconName["IconWifi"] = "twbs/wifi.svg";
    IconName["IconWind"] = "twbs/wind.svg";
    IconName["IconXCircleFill"] = "twbs/x-circle-fill.svg";
    IconName["IconXCircle"] = "twbs/x-circle.svg";
    IconName["IconXDiamondFill"] = "twbs/x-diamond-fill.svg";
    IconName["IconXDiamond"] = "twbs/x-diamond.svg";
    IconName["IconXLg"] = "twbs/x-lg.svg";
    IconName["IconXOctagonFill"] = "twbs/x-octagon-fill.svg";
    IconName["IconXOctagon"] = "twbs/x-octagon.svg";
    IconName["IconXSquareFill"] = "twbs/x-square-fill.svg";
    IconName["IconXSquare"] = "twbs/x-square.svg";
    IconName["IconX"] = "twbs/x.svg";
    IconName["IconZoomIn"] = "twbs/zoom-in.svg";
    IconName["IconZoomOut"] = "twbs/zoom-out.svg";
    IconName["IconIso7001RedCross"] = "iso7001/ISO-7001---Red-Cross.svg";
    IconName["IconIso7001RedSlash"] = "iso7001/ISO-7001---Red-Slash.svg";
    IconName["IconIso7001PiBp001"] = "iso7001/ISO-7001-PI-BP-001.svg";
    IconName["IconIso7001PiBp002"] = "iso7001/ISO-7001-PI-BP-002.svg";
    IconName["IconIso7001PiBp003"] = "iso7001/ISO-7001-PI-BP-003.svg";
    IconName["IconIso7001PiBp004"] = "iso7001/ISO-7001-PI-BP-004.svg";
    IconName["IconIso7001PiBp005"] = "iso7001/ISO-7001-PI-BP-005.svg";
    IconName["IconIso7001PiBp006"] = "iso7001/ISO-7001-PI-BP-006.svg";
    IconName["IconIso7001PiBp007"] = "iso7001/ISO-7001-PI-BP-007.svg";
    IconName["IconIso7001PiBp008"] = "iso7001/ISO-7001-PI-BP-008.svg";
    IconName["IconIso7001PiBp009"] = "iso7001/ISO-7001-PI-BP-009.svg";
    IconName["IconIso7001PiBp010"] = "iso7001/ISO-7001-PI-BP-010.svg";
    IconName["IconIso7001PiBp011"] = "iso7001/ISO-7001-PI-BP-011.svg";
    IconName["IconIso7001PiBp012"] = "iso7001/ISO-7001-PI-BP-012.svg";
    IconName["IconIso7001PiBp013"] = "iso7001/ISO-7001-PI-BP-013.svg";
    IconName["IconIso7001PiBp014"] = "iso7001/ISO-7001-PI-BP-014.svg";
    IconName["IconIso7001PiBp015"] = "iso7001/ISO-7001-PI-BP-015.svg";
    IconName["IconIso7001PiBp016"] = "iso7001/ISO-7001-PI-BP-016.svg";
    IconName["IconIso7001PiBp017"] = "iso7001/ISO-7001-PI-BP-017.svg";
    IconName["IconIso7001PiBp018"] = "iso7001/ISO-7001-PI-BP-018.svg";
    IconName["IconIso7001PiBp019"] = "iso7001/ISO-7001-PI-BP-019.svg";
    IconName["IconIso7001PiCf001"] = "iso7001/ISO-7001-PI-CF-001.svg";
    IconName["IconIso7001PiCf002"] = "iso7001/ISO-7001-PI-CF-002.svg";
    IconName["IconIso7001PiCf003"] = "iso7001/ISO-7001-PI-CF-003.svg";
    IconName["IconIso7001PiCf004"] = "iso7001/ISO-7001-PI-CF-004.svg";
    IconName["IconIso7001PiCf005"] = "iso7001/ISO-7001-PI-CF-005.svg";
    IconName["IconIso7001PiCf006"] = "iso7001/ISO-7001-PI-CF-006.svg";
    IconName["IconIso7001PiCf007"] = "iso7001/ISO-7001-PI-CF-007.svg";
    IconName["IconIso7001PiCf008"] = "iso7001/ISO-7001-PI-CF-008.svg";
    IconName["IconIso7001PiCf009"] = "iso7001/ISO-7001-PI-CF-009.svg";
    IconName["IconIso7001PiCf010"] = "iso7001/ISO-7001-PI-CF-010.svg";
    IconName["IconIso7001PiCf011"] = "iso7001/ISO-7001-PI-CF-011.svg";
    IconName["IconIso7001PiCf012"] = "iso7001/ISO-7001-PI-CF-012.svg";
    IconName["IconIso7001PiCf014"] = "iso7001/ISO-7001-PI-CF-014.svg";
    IconName["IconIso7001PiCf015"] = "iso7001/ISO-7001-PI-CF-015.svg";
    IconName["IconIso7001PiCf016"] = "iso7001/ISO-7001-PI-CF-016.svg";
    IconName["IconIso7001PiCf017"] = "iso7001/ISO-7001-PI-CF-017.svg";
    IconName["IconIso7001PiCf018"] = "iso7001/ISO-7001-PI-CF-018.svg";
    IconName["IconIso7001PiCf019"] = "iso7001/ISO-7001-PI-CF-019.svg";
    IconName["IconIso7001PiCf020"] = "iso7001/ISO-7001-PI-CF-020.svg";
    IconName["IconIso7001PiCf021"] = "iso7001/ISO-7001-PI-CF-021.svg";
    IconName["IconIso7001PiCf022"] = "iso7001/ISO-7001-PI-CF-022.svg";
    IconName["IconIso7001PiPf001"] = "iso7001/ISO-7001-PI-PF-001.svg";
    IconName["IconIso7001PiPf002"] = "iso7001/ISO-7001-PI-PF-002.svg";
    IconName["IconIso7001PiPf003"] = "iso7001/ISO-7001-PI-PF-003.svg";
    IconName["IconIso7001PiPf004"] = "iso7001/ISO-7001-PI-PF-004.svg";
    IconName["IconIso7001PiPf005"] = "iso7001/ISO-7001-PI-PF-005.svg";
    IconName["IconIso7001PiPf006"] = "iso7001/ISO-7001-PI-PF-006.svg";
    IconName["IconIso7001PiPf007"] = "iso7001/ISO-7001-PI-PF-007.svg";
    IconName["IconIso7001PiPf008"] = "iso7001/ISO-7001-PI-PF-008.svg";
    IconName["IconIso7001PiPf009"] = "iso7001/ISO-7001-PI-PF-009.svg";
    IconName["IconIso7001PiPf010"] = "iso7001/ISO-7001-PI-PF-010.svg";
    IconName["IconIso7001PiPf011"] = "iso7001/ISO-7001-PI-PF-011.svg";
    IconName["IconIso7001PiPf012"] = "iso7001/ISO-7001-PI-PF-012.svg";
    IconName["IconIso7001PiPf013"] = "iso7001/ISO-7001-PI-PF-013.svg";
    IconName["IconIso7001PiPf014"] = "iso7001/ISO-7001-PI-PF-014.svg";
    IconName["IconIso7001PiPf015"] = "iso7001/ISO-7001-PI-PF-015.svg";
    IconName["IconIso7001PiPf016"] = "iso7001/ISO-7001-PI-PF-016.svg";
    IconName["IconIso7001PiPf017"] = "iso7001/ISO-7001-PI-PF-017.svg";
    IconName["IconIso7001PiPf018"] = "iso7001/ISO-7001-PI-PF-018.svg";
    IconName["IconIso7001PiPf019"] = "iso7001/ISO-7001-PI-PF-019.svg";
    IconName["IconIso7001PiPf020"] = "iso7001/ISO-7001-PI-PF-020.svg";
    IconName["IconIso7001PiPf021"] = "iso7001/ISO-7001-PI-PF-021.svg";
    IconName["IconIso7001PiPf022"] = "iso7001/ISO-7001-PI-PF-022.svg";
    IconName["IconIso7001PiPf023"] = "iso7001/ISO-7001-PI-PF-023.svg";
    IconName["IconIso7001PiPf024"] = "iso7001/ISO-7001-PI-PF-024.svg";
    IconName["IconIso7001PiPf025"] = "iso7001/ISO-7001-PI-PF-025.svg";
    IconName["IconIso7001PiPf026"] = "iso7001/ISO-7001-PI-PF-026.svg";
    IconName["IconIso7001PiPf027"] = "iso7001/ISO-7001-PI-PF-027.svg";
    IconName["IconIso7001PiPf028"] = "iso7001/ISO-7001-PI-PF-028.svg";
    IconName["IconIso7001PiPf029"] = "iso7001/ISO-7001-PI-PF-029.svg";
    IconName["IconIso7001PiPf030"] = "iso7001/ISO-7001-PI-PF-030.svg";
    IconName["IconIso7001PiPf031"] = "iso7001/ISO-7001-PI-PF-031.svg";
    IconName["IconIso7001PiPf032"] = "iso7001/ISO-7001-PI-PF-032.svg";
    IconName["IconIso7001PiPf033"] = "iso7001/ISO-7001-PI-PF-033.svg";
    IconName["IconIso7001PiPf034"] = "iso7001/ISO-7001-PI-PF-034.svg";
    IconName["IconIso7001PiPf036"] = "iso7001/ISO-7001-PI-PF-036.svg";
    IconName["IconIso7001PiPf037"] = "iso7001/ISO-7001-PI-PF-037.svg";
    IconName["IconIso7001PiPf043"] = "iso7001/ISO-7001-PI-PF-043.svg";
    IconName["IconIso7001PiPf044"] = "iso7001/ISO-7001-PI-PF-044.svg";
    IconName["IconIso7001PiPf045"] = "iso7001/ISO-7001-PI-PF-045.svg";
    IconName["IconIso7001PiPf046"] = "iso7001/ISO-7001-PI-PF-046.svg";
    IconName["IconIso7001PiPf047"] = "iso7001/ISO-7001-PI-PF-047.svg";
    IconName["IconIso7001PiPf048"] = "iso7001/ISO-7001-PI-PF-048.svg";
    IconName["IconIso7001PiPf049"] = "iso7001/ISO-7001-PI-PF-049.svg";
    IconName["IconIso7001PiPf050"] = "iso7001/ISO-7001-PI-PF-050.svg";
    IconName["IconIso7001PiPf051"] = "iso7001/ISO-7001-PI-PF-051.svg";
    IconName["IconIso7001PiPf054"] = "iso7001/ISO-7001-PI-PF-054.svg";
    IconName["IconIso7001PiPf055"] = "iso7001/ISO-7001-PI-PF-055.svg";
    IconName["IconIso7001PiPf056"] = "iso7001/ISO-7001-PI-PF-056.svg";
    IconName["IconIso7001PiPf057"] = "iso7001/ISO-7001-PI-PF-057.svg";
    IconName["IconIso7001PiPf058"] = "iso7001/ISO-7001-PI-PF-058.svg";
    IconName["IconIso7001PiPf059"] = "iso7001/ISO-7001-PI-PF-059.svg";
    IconName["IconIso7001PiPf062"] = "iso7001/ISO-7001-PI-PF-062.svg";
    IconName["IconIso7001PiPf063"] = "iso7001/ISO-7001-PI-PF-063.svg";
    IconName["IconIso7001PiPf064"] = "iso7001/ISO-7001-PI-PF-064.svg";
    IconName["IconIso7001PiPf065"] = "iso7001/ISO-7001-PI-PF-065.svg";
    IconName["IconIso7001PiPf066"] = "iso7001/ISO-7001-PI-PF-066.svg";
    IconName["IconIso7001PiPf067"] = "iso7001/ISO-7001-PI-PF-067.svg";
    IconName["IconIso7001PiPf068"] = "iso7001/ISO-7001-PI-PF-068.svg";
    IconName["IconIso7001PiPf069"] = "iso7001/ISO-7001-PI-PF-069.svg";
    IconName["IconIso7001PiPf070"] = "iso7001/ISO-7001-PI-PF-070.svg";
    IconName["IconIso7001PiPf072"] = "iso7001/ISO-7001-PI-PF-072.svg";
    IconName["IconIso7001PiPf073"] = "iso7001/ISO-7001-PI-PF-073.svg";
    IconName["IconIso7001PiPf074"] = "iso7001/ISO-7001-PI-PF-074.svg";
    IconName["IconIso7001PiPf075"] = "iso7001/ISO-7001-PI-PF-075.svg";
    IconName["IconIso7001PiPf076"] = "iso7001/ISO-7001-PI-PF-076.svg";
    IconName["IconIso7001PiPf077"] = "iso7001/ISO-7001-PI-PF-077.svg";
    IconName["IconIso7001PiPf078"] = "iso7001/ISO-7001-PI-PF-078.svg";
    IconName["IconIso7001PiPf079"] = "iso7001/ISO-7001-PI-PF-079.svg";
    IconName["IconIso7001PiPf080"] = "iso7001/ISO-7001-PI-PF-080.svg";
    IconName["IconIso7001PiPf081"] = "iso7001/ISO-7001-PI-PF-081.svg";
    IconName["IconIso7001PiPf082"] = "iso7001/ISO-7001-PI-PF-082.svg";
    IconName["IconIso7001PiSa001"] = "iso7001/ISO-7001-PI-SA-001.svg";
    IconName["IconIso7001PiSa002"] = "iso7001/ISO-7001-PI-SA-002.svg";
    IconName["IconIso7001PiSa003"] = "iso7001/ISO-7001-PI-SA-003.svg";
    IconName["IconIso7001PiSa004"] = "iso7001/ISO-7001-PI-SA-004.svg";
    IconName["IconIso7001PiTc001"] = "iso7001/ISO-7001-PI-TC-001.svg";
    IconName["IconIso7001PiTc002"] = "iso7001/ISO-7001-PI-TC-002.svg";
    IconName["IconIso7001PiTc003"] = "iso7001/ISO-7001-PI-TC-003.svg";
    IconName["IconIso7001PiTc004"] = "iso7001/ISO-7001-PI-TC-004.svg";
    IconName["IconIso7001PiTc005"] = "iso7001/ISO-7001-PI-TC-005.svg";
    IconName["IconIso7001PiTc006"] = "iso7001/ISO-7001-PI-TC-006.svg";
    IconName["IconIso7001PiTc007"] = "iso7001/ISO-7001-PI-TC-007.svg";
    IconName["IconIso7001PiTc008"] = "iso7001/ISO-7001-PI-TC-008.svg";
    IconName["IconIso7001PiTc009"] = "iso7001/ISO-7001-PI-TC-009.svg";
    IconName["IconIso7001PiTc010"] = "iso7001/ISO-7001-PI-TC-010.svg";
    IconName["IconIso7001PiTc011"] = "iso7001/ISO-7001-PI-TC-011.svg";
    IconName["IconIso7001PiTc012"] = "iso7001/ISO-7001-PI-TC-012.svg";
    IconName["IconIso7001PiTc013"] = "iso7001/ISO-7001-PI-TC-013.svg";
    IconName["IconIso7001PiTc014"] = "iso7001/ISO-7001-PI-TC-014.svg";
    IconName["IconIso7001PiTc015"] = "iso7001/ISO-7001-PI-TC-015.svg";
    IconName["IconIso7001PiTc016"] = "iso7001/ISO-7001-PI-TC-016.svg";
    IconName["IconIso7001PiTc017"] = "iso7001/ISO-7001-PI-TC-017.svg";
    IconName["IconIso7001PiTc018"] = "iso7001/ISO-7001-PI-TC-018.svg";
    IconName["IconIso7001PiTf001"] = "iso7001/ISO-7001-PI-TF-001.svg";
    IconName["IconIso7001PiTf002"] = "iso7001/ISO-7001-PI-TF-002.svg";
    IconName["IconIso7001PiTf003"] = "iso7001/ISO-7001-PI-TF-003.svg";
    IconName["IconIso7001PiTf004"] = "iso7001/ISO-7001-PI-TF-004.svg";
    IconName["IconIso7001PiTf005"] = "iso7001/ISO-7001-PI-TF-005.svg";
    IconName["IconIso7001PiTf006"] = "iso7001/ISO-7001-PI-TF-006.svg";
    IconName["IconIso7001PiTf007"] = "iso7001/ISO-7001-PI-TF-007.svg";
    IconName["IconIso7001PiTf008"] = "iso7001/ISO-7001-PI-TF-008.svg";
    IconName["IconIso7001PiTf009"] = "iso7001/ISO-7001-PI-TF-009.svg";
    IconName["IconIso7001PiTf010"] = "iso7001/ISO-7001-PI-TF-010.svg";
    IconName["IconIso7001PiTf011"] = "iso7001/ISO-7001-PI-TF-011.svg";
    IconName["IconIso7001PiTf012"] = "iso7001/ISO-7001-PI-TF-012.svg";
    IconName["IconIso7001PiTf013"] = "iso7001/ISO-7001-PI-TF-013.svg";
    IconName["IconIso7001PiTf014"] = "iso7001/ISO-7001-PI-TF-014.svg";
    IconName["IconIso7001PiTf015"] = "iso7001/ISO-7001-PI-TF-015.svg";
    IconName["IconIso7001PiTf016"] = "iso7001/ISO-7001-PI-TF-016.svg";
    IconName["IconIso7001PiTf017"] = "iso7001/ISO-7001-PI-TF-017.svg";
    IconName["IconIso7001PiTf018"] = "iso7001/ISO-7001-PI-TF-018.svg";
    IconName["IconIso7001PiTf019"] = "iso7001/ISO-7001-PI-TF-019.svg";
    IconName["IconIso7001PiTf020"] = "iso7001/ISO-7001-PI-TF-020.svg";
    IconName["IconIso7001PiTf021"] = "iso7001/ISO-7001-PI-TF-021.svg";
    IconName["IconIso7001PiTf022"] = "iso7001/ISO-7001-PI-TF-022.svg";
    IconName["IconIso7001PiTf023"] = "iso7001/ISO-7001-PI-TF-023.svg";
    IconName["IconIso7001PiTf024"] = "iso7001/ISO-7001-PI-TF-024.svg";
    IconName["IconIso7001PiTf025"] = "iso7001/ISO-7001-PI-TF-025.svg";
    IconName["IconIso7001PiTf026"] = "iso7001/ISO-7001-PI-TF-026.svg";
    IconName["IconIso7001PiTf027"] = "iso7001/ISO-7001-PI-TF-027.svg";
    IconName["IconIso7001PiTf028"] = "iso7001/ISO-7001-PI-TF-028.svg";
    IconName["IconIso7001PiTf029"] = "iso7001/ISO-7001-PI-TF-029.svg";
    IconName["IconIso7001PiTf030"] = "iso7001/ISO-7001-PI-TF-030.svg";
    IconName["IconIso7001PiTf031"] = "iso7001/ISO-7001-PI-TF-031.svg";
    IconName["IconIso7001PiTf032"] = "iso7001/ISO-7001-PI-TF-032.svg";
    IconName["IconIso7001PiTf033"] = "iso7001/ISO-7001-PI-TF-033.svg";
    IconName["IconIso7001PiTf034"] = "iso7001/ISO-7001-PI-TF-034.svg";
    IconName["IconIso7001PiTf035"] = "iso7001/ISO-7001-PI-TF-035.svg";
    IconName["IconIso7001PiTf036"] = "iso7001/ISO-7001-PI-TF-036.svg";
    IconName["IconIso7001PiTf037"] = "iso7001/ISO-7001-PI-TF-037.svg";
    IconName["IconIso7001PiTf038"] = "iso7001/ISO-7001-PI-TF-038.svg";
    IconName["IconIso7001PiTf039"] = "iso7001/ISO-7001-PI-TF-039.svg";
    IconName["IconIso7001PiTf040"] = "iso7001/ISO-7001-PI-TF-040.svg";
    IconName["IconIso7001PiTf041"] = "iso7001/ISO-7001-PI-TF-041.svg";
    IconName["IconIso7001PiTf042"] = "iso7001/ISO-7001-PI-TF-042.svg";
    IconName["IconIso7001PiTf043"] = "iso7001/ISO-7001-PI-TF-043.svg";
    IconName["IconIso7001PiTf044"] = "iso7001/ISO-7001-PI-TF-044.svg";
    IconName["IconDin48442DP017"] = "iso7010/DIN-4844-2-D-P017.svg";
    IconName["IconIso7010E002New"] = "iso7010/ISO-7010-E002-new.svg";
    IconName["IconIso7010E003FirstAidSign"] = "iso7010/ISO-7010-E003---First-aid-sign.svg";
    IconName["IconIso7010E004"] = "iso7010/ISO-7010-E004.svg";
    IconName["IconIso7010E007"] = "iso7010/ISO-7010-E007.svg";
    IconName["IconIso7010E008"] = "iso7010/ISO-7010-E008.svg";
    IconName["IconIso7010E009"] = "iso7010/ISO-7010-E009.svg";
    IconName["IconIso7010E010"] = "iso7010/ISO-7010-E010.svg";
    IconName["IconIso7010E011"] = "iso7010/ISO-7010-E011.svg";
    IconName["IconIso7010E012"] = "iso7010/ISO-7010-E012.svg";
    IconName["IconIso7010E013"] = "iso7010/ISO-7010-E013.svg";
    IconName["IconIso7010E016"] = "iso7010/ISO-7010-E016.svg";
    IconName["IconIso7010E017"] = "iso7010/ISO-7010-E017.svg";
    IconName["IconIso7010E018"] = "iso7010/ISO-7010-E018.svg";
    IconName["IconIso7010E019"] = "iso7010/ISO-7010-E019.svg";
    IconName["IconIso7010F001"] = "iso7010/ISO-7010-F001.svg";
    IconName["IconIso7010F002"] = "iso7010/ISO-7010-F002.svg";
    IconName["IconIso7010F003"] = "iso7010/ISO-7010-F003.svg";
    IconName["IconIso7010F004"] = "iso7010/ISO-7010-F004.svg";
    IconName["IconIso7010F005"] = "iso7010/ISO-7010-F005.svg";
    IconName["IconIso7010F006"] = "iso7010/ISO-7010-F006.svg";
    IconName["IconIso7010F007"] = "iso7010/ISO-7010-F007.svg";
    IconName["IconIso7010M001"] = "iso7010/ISO-7010-M001.svg";
    IconName["IconIso7010M002"] = "iso7010/ISO-7010-M002.svg";
    IconName["IconIso7010M003"] = "iso7010/ISO-7010-M003.svg";
    IconName["IconIso7010M004"] = "iso7010/ISO-7010-M004.svg";
    IconName["IconIso7010M005"] = "iso7010/ISO-7010-M005.svg";
    IconName["IconIso7010M006"] = "iso7010/ISO-7010-M006.svg";
    IconName["IconIso7010M007"] = "iso7010/ISO-7010-M007.svg";
    IconName["IconIso7010M008"] = "iso7010/ISO-7010-M008.svg";
    IconName["IconIso7010M009"] = "iso7010/ISO-7010-M009.svg";
    IconName["IconIso7010M010"] = "iso7010/ISO-7010-M010.svg";
    IconName["IconIso7010M011"] = "iso7010/ISO-7010-M011.svg";
    IconName["IconIso7010M012"] = "iso7010/ISO-7010-M012.svg";
    IconName["IconIso7010M013"] = "iso7010/ISO-7010-M013.svg";
    IconName["IconIso7010M014"] = "iso7010/ISO-7010-M014.svg";
    IconName["IconIso7010M015"] = "iso7010/ISO-7010-M015.svg";
    IconName["IconIso7010M016"] = "iso7010/ISO-7010-M016.svg";
    IconName["IconIso7010M017"] = "iso7010/ISO-7010-M017.svg";
    IconName["IconIso7010M018"] = "iso7010/ISO-7010-M018.svg";
    IconName["IconIso7010M019"] = "iso7010/ISO-7010-M019.svg";
    IconName["IconIso7010M020"] = "iso7010/ISO-7010-M020.svg";
    IconName["IconIso7010M021"] = "iso7010/ISO-7010-M021.svg";
    IconName["IconIso7010M022"] = "iso7010/ISO-7010-M022.svg";
    IconName["IconIso7010M023"] = "iso7010/ISO-7010-M023.svg";
    IconName["IconIso7010M024"] = "iso7010/ISO-7010-M024.svg";
    IconName["IconIso7010M025"] = "iso7010/ISO-7010-M025.svg";
    IconName["IconIso7010M026"] = "iso7010/ISO-7010-M026.svg";
    IconName["IconIso7010M027MandatoryInstallOrCheckGuard"] = "iso7010/ISO-7010-M027-mandatory-install-or-check-guard.svg";
    IconName["IconIso7010M028MandatoryInstallLocksAndKeepLocked"] = "iso7010/ISO-7010-M028-mandatory-install-locks-and-keep-locked.svg";
    IconName["IconIso7010M029MandatorySoundYourHorn"] = "iso7010/ISO-7010-M029-mandatory-sound-your-horn.svg";
    IconName["IconIso7010M030MandatoryPlaceTrashInTheBin"] = "iso7010/ISO-7010-M030-mandatory-place-trash-in-the-bin.svg";
    IconName["IconIso7010M031MandatoryUseGuardToProtectFromInjuryFromTheTableSaw"] = "iso7010/ISO-7010-M031-mandatory-use-guard-to-protect-from-injury-from-the-table-saw.svg";
    IconName["IconIso7010M032MandatoryUseFootwearWithAntiStaticOrAntiSparkFeatures"] = "iso7010/ISO-7010-M032-mandatory-use-footwear-with-anti-static-or-anti-spark-features.svg";
    IconName["IconIso7010M033MandatoryLowerSafetyRestrainingBarOnSkiChairlift"] = "iso7010/ISO-7010-M033-mandatory-lower-safety-restraining-bar-on-ski-chairlift.svg";
    IconName["IconIso7010M034MandatoryRaiseSafetyRestrainingBarOnSkiChairlift"] = "iso7010/ISO-7010-M034-mandatory-raise-safety-restraining-bar-on-ski-chairlift.svg";
    IconName["IconIso7010M035MandatoryExitTowpathAfterFalling"] = "iso7010/ISO-7010-M035-mandatory-exit-towpath-after-falling.svg";
    IconName["IconIso7010M036MandatoryKeepSkiTipsUp"] = "iso7010/ISO-7010-M036-mandatory-keep-ski-tips-up.svg";
    IconName["IconIso7010M037MandatoryCloseAndSecureTheHatchLifeboatLaunchSequence"] = "iso7010/ISO-7010-M037-mandatory-close-and-secure-the-hatch-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M038MandatoryStartTheMotorLifeboatLaunchSequence"] = "iso7010/ISO-7010-M038-mandatory-start-the-motor-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M039MandatoryLowerTheLifeboatToTheWaterLifeboatLaunchSequence"] = "iso7010/ISO-7010-M039-mandatory-lower-the-lifeboat-to-the-water-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M040MandatoryLowerTheLifeboatToTheWaterLifeboatLaunchSequence"] = "iso7010/ISO-7010-M040-mandatory-lower-the-lifeboat-to-the-water-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M041MandatoryLowerTheRescueBoatToTheWaterLifeboatLaunchSequence"] = "iso7010/ISO-7010-M041-mandatory-lower-the-rescue-boat-to-the-water-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M042MandatoryReleaseTheHooksHoldingTheLifeboatLifeboatLaunchSequence"] = "iso7010/ISO-7010-M042-mandatory-release-the-hooks-holding-the-lifeboat-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M043MandatoryStartTheWaterSprayForTheLifeboatLifeboatLaunchSequence"] = "iso7010/ISO-7010-M043-mandatory-start-the-water-spray-for-the-lifeboat-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M044MandatoryStartTheAirSupplyForTheLifeboatLifeboatLaunchSequence"] = "iso7010/ISO-7010-M044-mandatory-start-the-air-supply-for-the-lifeboat-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M045MandatoryReleaseTheRopesGripesLifeboatLaunchSequence"] = "iso7010/ISO-7010-M045-mandatory-release-the-ropes-gripes-lifeboat-launch-sequence.svg";
    IconName["IconIso7010M046MandatorySecureGasCylinders"] = "iso7010/ISO-7010-M046-mandatory-secure-gas-cylinders.svg";
    IconName["IconIso7010M047MandatoryUseBreathingEquipmentScba"] = "iso7010/ISO-7010-M047-mandatory-use-breathing-equipment-SCBA.svg";
    IconName["IconIso7010M048GasdetektorBenutzen"] = "iso7010/ISO-7010-M048-Gasdetektor-benutzen.svg";
    IconName["IconIso7010M049MandatoryUsePersonalProtectiveEquipmentForSport"] = "iso7010/ISO-7010-M049-mandatory-use-personal-protective-equipment-for-sport.svg";
    IconName["IconIso7010M050MandatoryExitSledTobogganToTheLeft"] = "iso7010/ISO-7010-M050-mandatory-exit-sled-toboggan-to-the-left.svg";
    IconName["IconIso7010M051MandatoryExitSledTobogganToTheRight"] = "iso7010/ISO-7010-M051-mandatory-exit-sled-toboggan-to-the-right.svg";
    IconName["IconIso7010M052MandatoryKeepASafeDistanceBetweenSledsToboggans"] = "iso7010/ISO-7010-M052-mandatory-keep-a-safe-distance-between-sleds-toboggans.svg";
    IconName["IconIso7010M053MandatoryWearPersonalFloatationDevicePfdLifejacket"] = "iso7010/ISO-7010-M053-mandatory-wear-personal-floatation-device-PFD-lifejacket.svg";
    IconName["IconIso7010M054SuperviseChildrenDuringAquaticActivities"] = "iso7010/ISO-7010-M054-supervise-children-during-aquatic-activities.svg";
    IconName["IconIso7010M055"] = "iso7010/ISO-7010-M055.svg";
    IconName["IconIso7010P001"] = "iso7010/ISO-7010-P001.svg";
    IconName["IconIso7010P002"] = "iso7010/ISO-7010-P002.svg";
    IconName["IconIso7010P003"] = "iso7010/ISO-7010-P003.svg";
    IconName["IconIso7010P004"] = "iso7010/ISO-7010-P004.svg";
    IconName["IconIso7010P005"] = "iso7010/ISO-7010-P005.svg";
    IconName["IconIso7010P006"] = "iso7010/ISO-7010-P006.svg";
    IconName["IconIso7010P007"] = "iso7010/ISO-7010-P007.svg";
    IconName["IconIso7010P008"] = "iso7010/ISO-7010-P008.svg";
    IconName["IconIso7010P010"] = "iso7010/ISO-7010-P010.svg";
    IconName["IconIso7010P011"] = "iso7010/ISO-7010-P011.svg";
    IconName["IconIso7010P012"] = "iso7010/ISO-7010-P012.svg";
    IconName["IconIso7010P013"] = "iso7010/ISO-7010-P013.svg";
    IconName["IconIso7010P014"] = "iso7010/ISO-7010-P014.svg";
    IconName["IconIso7010P015"] = "iso7010/ISO-7010-P015.svg";
    IconName["IconIso7010P017"] = "iso7010/ISO-7010-P017.svg";
    IconName["IconIso7010P018"] = "iso7010/ISO-7010-P018.svg";
    IconName["IconIso7010P019"] = "iso7010/ISO-7010-P019.svg";
    IconName["IconIso7010P020"] = "iso7010/ISO-7010-P020.svg";
    IconName["IconIso7010P021"] = "iso7010/ISO-7010-P021.svg";
    IconName["IconIso7010P022"] = "iso7010/ISO-7010-P022.svg";
    IconName["IconIso7010P023"] = "iso7010/ISO-7010-P023.svg";
    IconName["IconIso7010P024"] = "iso7010/ISO-7010-P024.svg";
    IconName["IconIso7010P025"] = "iso7010/ISO-7010-P025.svg";
    IconName["IconIso7010P026"] = "iso7010/ISO-7010-P026.svg";
    IconName["IconIso7010P027"] = "iso7010/ISO-7010-P027.svg";
    IconName["IconIso7010P028"] = "iso7010/ISO-7010-P028.svg";
    IconName["IconIso7010P029"] = "iso7010/ISO-7010-P029.svg";
    IconName["IconIso7010P030"] = "iso7010/ISO-7010-P030.svg";
    IconName["IconIso7010P031"] = "iso7010/ISO-7010-P031.svg";
    IconName["IconIso7010P032"] = "iso7010/ISO-7010-P032.svg";
    IconName["IconIso7010P033"] = "iso7010/ISO-7010-P033.svg";
    IconName["IconIso7010P034"] = "iso7010/ISO-7010-P034.svg";
    IconName["IconIso7010SafeConditionArrow1"] = "iso7010/ISO-7010-Safe-condition-arrow-1.svg";
    IconName["IconIso7010SafeConditionArrow2"] = "iso7010/ISO-7010-Safe-condition-arrow-2.svg";
    IconName["IconIso7010W001"] = "iso7010/ISO-7010-W001.svg";
    IconName["IconIso7010W002"] = "iso7010/ISO-7010-W002.svg";
    IconName["IconIso7010W003"] = "iso7010/ISO-7010-W003.svg";
    IconName["IconIso7010W004"] = "iso7010/ISO-7010-W004.svg";
    IconName["IconIso7010W005"] = "iso7010/ISO-7010-W005.svg";
    IconName["IconIso7010W006"] = "iso7010/ISO-7010-W006.svg";
    IconName["IconIso7010W007"] = "iso7010/ISO-7010-W007.svg";
    IconName["IconIso7010W008"] = "iso7010/ISO-7010-W008.svg";
    IconName["IconIso7010W009"] = "iso7010/ISO-7010-W009.svg";
    IconName["IconIso7010W010"] = "iso7010/ISO-7010-W010.svg";
    IconName["IconIso7010W011"] = "iso7010/ISO-7010-W011.svg";
    IconName["IconIso7010W012"] = "iso7010/ISO-7010-W012.svg";
    IconName["IconIso7010W013"] = "iso7010/ISO-7010-W013.svg";
    IconName["IconIso7010W014"] = "iso7010/ISO-7010-W014.svg";
    IconName["IconIso7010W015"] = "iso7010/ISO-7010-W015.svg";
    IconName["IconIso7010W016"] = "iso7010/ISO-7010-W016.svg";
    IconName["IconIso7010W017"] = "iso7010/ISO-7010-W017.svg";
    IconName["IconIso7010W018"] = "iso7010/ISO-7010-W018.svg";
    IconName["IconIso7010W019"] = "iso7010/ISO-7010-W019.svg";
    IconName["IconIso7010W020"] = "iso7010/ISO-7010-W020.svg";
    IconName["IconIso7010W021"] = "iso7010/ISO-7010-W021.svg";
    IconName["IconIso7010W022"] = "iso7010/ISO-7010-W022.svg";
    IconName["IconIso7010W023"] = "iso7010/ISO-7010-W023.svg";
    IconName["IconIso7010W024"] = "iso7010/ISO-7010-W024.svg";
    IconName["IconIso7010W025"] = "iso7010/ISO-7010-W025.svg";
    IconName["IconIso7010W026"] = "iso7010/ISO-7010-W026.svg";
    IconName["IconIso7010W027"] = "iso7010/ISO-7010-W027.svg";
    IconName["IconIso7010W028"] = "iso7010/ISO-7010-W028.svg";
    IconName["IconIso7010W029"] = "iso7010/ISO-7010-W029.svg";
    IconName["IconIso7010W031WarningHandInjuryFromWorkpieceMovingInPressBrakeMachinery"] = "iso7010/ISO-7010-W031-warning-hand-injury-from-workpiece-moving-in-press-brake-machinery.svg";
    IconName["IconIso7010W035"] = "iso7010/ISO-7010-W035.svg";
    IconName["IconIso7010W039"] = "iso7010/ISO-7010-W039.svg";
    IconName["IconIso7010W040WarningRoofAvalanche"] = "iso7010/ISO-7010-W040-warning-roof-avalanche.svg";
    IconName["IconIso7010W041WarningBreathingHazard"] = "iso7010/ISO-7010-W041-warning-breathing-hazard.svg";
    IconName["IconIso7010W042WarningArcFlashHazard"] = "iso7010/ISO-7010-W042-warning-arc-flash-hazard.svg";
    IconName["IconIso7010W043WarningThinIce"] = "iso7010/ISO-7010-W043-warning-thin-ice.svg";
    IconName["IconIso7010W044WarningSlipway"] = "iso7010/ISO-7010-W044-warning-slipway.svg";
    IconName["IconIso7010W045WarningWaterSkiingOrTowedWaterActivityArea"] = "iso7010/ISO-7010-W045-warning-water-skiing-or-towed-water-activity-area.svg";
    IconName["IconIso7010W046WarningSurfing"] = "iso7010/ISO-7010-W046-warning-surfing.svg";
    IconName["IconIso7010W047WarningDeepWater"] = "iso7010/ISO-7010-W047-warning-deep-water.svg";
    IconName["IconIso7010W048WarningShallowWater"] = "iso7010/ISO-7010-W048-warning-shallow-water.svg";
    IconName["IconIso7010W049WarningSubmergedObjects"] = "iso7010/ISO-7010-W049-warning-submerged-objects.svg";
    IconName["IconIso7010W050WarningSuddenDropInSwimmingPool"] = "iso7010/ISO-7010-W050-warning-sudden-drop-in-swimming-pool.svg";
    IconName["IconIso7010W051WarningNoGuardRailAndUnprotectedEdges"] = "iso7010/ISO-7010-W051-warning-no-guard-rail-and-unprotected-edges.svg";
    IconName["IconIso7010W052WarningUnstableCliffEdge"] = "iso7010/ISO-7010-W052-warning-unstable-cliff-edge.svg";
    IconName["IconIso7010W053WarningUnstableCliff"] = "iso7010/ISO-7010-W053-warning-unstable-cliff.svg";
    IconName["IconIso7010W054WarningSharks"] = "iso7010/ISO-7010-W054-warning-sharks.svg";
    IconName["IconIso7010W055WarningSewageEffluentOutfall"] = "iso7010/ISO-7010-W055-warning-sewage-effluent-outfall.svg";
    IconName["IconIso7010W056WarningTsunamiHazardZone"] = "iso7010/ISO-7010-W056-warning-tsunami-hazard-zone.svg";
    IconName["IconIso7010W057WarningStrongCurrents"] = "iso7010/ISO-7010-W057-warning-strong-currents.svg";
    IconName["IconIso7010W058WarningBoatingArea"] = "iso7010/ISO-7010-W058-warning-boating-area.svg";
    IconName["IconIso7010W059SandYachting"] = "iso7010/ISO-7010-W059-sand-yachting.svg";
    IconName["IconIso7010W060WarningIncomingTides"] = "iso7010/ISO-7010-W060-warning-incoming-tides.svg";
    IconName["IconIso7010W061WarningQuicksandMudDeepMudOrSilt"] = "iso7010/ISO-7010-W061-warning-quicksand-mud-deep-mud-or-silt.svg";
    IconName["IconIso7010W062WarningKiteSurfing"] = "iso7010/ISO-7010-W062-warning-kite-surfing.svg";
    IconName["IconIso7010W063WarningParasailing"] = "iso7010/ISO-7010-W063-warning-parasailing.svg";
    IconName["IconIso7010W064WarningStrongWinds"] = "iso7010/ISO-7010-W064-warning-strong-winds.svg";
    IconName["IconIso7010W065WarningHighSurfOrLargeBreakingWaves"] = "iso7010/ISO-7010-W065-warning-high-surf-or-large-breaking-waves.svg";
    IconName["IconIso7010W066WarningSuddenDropToDeepWater"] = "iso7010/ISO-7010-W066-warning-Sudden-drop-to-deep-water.svg";
    IconName["IconIso7010W067WarningAlligatorsCaymansAndCrocodiles"] = "iso7010/ISO-7010-W067-warning-alligators-caymans-and-crocodiles.svg";
    IconName["IconSignFirstAid"] = "iso7010/Sign-first-aid.svg";
})(IconName || (IconName = {}));
//# sourceMappingURL=IconName.js.map